// extracted by mini-css-extract-plugin
export default {"wrap":"SearchBar_wrap__vnMBP","input":"SearchBar_input__B-Hvz","icon":"SearchBar_icon__5tunU","clear":"SearchBar_clear__6ksGL"};